import { Box, Stack } from "@mui/material";

import { UserPermission } from "@/common/contexts/current-user-context/CurrentUserContextProvider.types";
import withAuthorization from "@/common/hocs/with-authorization/withAuthorization";

import { ParameterEditor } from "./components/parameter-editor/ParameterEditor";
import { ParameterSelect } from "./components/parameter-select/ParameterSelect";
import { useCalculationParametersSettings } from "./hooks/useCalculationParametersSettings";

function CalculationParametersSettingsInner() {
  const {
    parameters,
    selectedParameter,
    formik,
    isSaving,
    handleSelectParameter,
    handleAddEntry,
    handleRemoveNewEntry,
    handleDeleteEntry,
  } = useCalculationParametersSettings();

  return (
    <Stack flex={1} minHeight={0} gap={3} pt={1}>
      <Box maxWidth={400}>
        <ParameterSelect
          parameters={parameters}
          selectedParameter={selectedParameter}
          onSelect={handleSelectParameter}
        />
      </Box>

      <ParameterEditor
        parameter={selectedParameter}
        formik={formik}
        isSaving={isSaving}
        onAddEntry={handleAddEntry}
        onRemoveNewEntry={handleRemoveNewEntry}
        onDeleteEntry={handleDeleteEntry}
      />
    </Stack>
  );
}

export const CalculationParametersSettings = withAuthorization(
  CalculationParametersSettingsInner,
  UserPermission.Supervisor
);
